import { PayoutMethodsPerCountryState } from 'modules/host-payout-methods/context/PayoutFormContext';

export default function (
  state: PayoutMethodsPerCountryState,
  action,
): PayoutMethodsPerCountryState {
  switch (action.type) {
    case 'FETCH_AVAILABLE_PAYOUT_METHODS_PER_COUNTRY':
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case 'FETCH_AVAILABLE_PAYOUT_METHODS_PER_COUNTRY:SUCCESS':
      return {
        ...state,
        data: Object.assign(state.data, {
          [action.country]: action.payoutMethodsPerCountry,
        }),
        loading: false,
        error: undefined,
      };
    case 'FETCH_AVAILABLE_PAYOUT_METHODS_PER_COUNTRY:ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };
  }
  return state;
}
